"use client";

import { usePathname } from "next/navigation";
import { toPublicPathname } from "@/app/utils/helpers/public-pathname";

/**
 * Drop-in replacement for `usePathname()` in frontend client components.
 * Returns the public path (without the internal `/t/[tenant]` segment) on
 * server and client alike, avoiding hydration mismatches after the proxy
 * rewrite.
 */
export function usePublicPathname(): string {
  return toPublicPathname(usePathname());
}
